import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <section className="hero-banner">
          <video className="hero-video" autoPlay loop muted playsInline>
            <source src="/main/main1.mp4" type="video/mp4" />
          </video>
          <div className="hero-content">
            <div className="hero-buttons">
              <Link to="/shop" onClick={toTop} className="btn-hero">
                Women's Stretch Zion™
              </Link>
              <Link to="/shop" onClick={toTop} className="btn-hero">
                Men's Stretch Zion™
              </Link>
            </div>
          </div>
        </section>

        <section className="shop-by-category">
          <h2 className="section-title">Shop by Category</h2>
          <div className="category-grid">
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-1.png" alt="Women's Tops" />
                </div>
                <span className="category-label">Women's Tops</span>
              </Link>
            </div>
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-2.png" alt="Men's Tops" />
                </div>
                <span className="category-label">Men's Tops</span>
              </Link>
            </div>
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-3.png" alt="Women's Bottoms" />
                </div>
                <span className="category-label">Women's Bottoms</span>
              </Link>
            </div>
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-4.png" alt="Men's Bottoms" />
                </div>
                <span className="category-label">Men's Bottoms</span>
              </Link>
            </div>
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-5.jpeg" alt="Women's Swim" />
                </div>
                <span className="category-label">Women's Swim</span>
              </Link>
            </div>
            <div className="category-card">
              <Link to="/shop" onClick={toTop}>
                <div className="image-container">
                  <img src="/main/main2-6.jpeg" alt="Men's Swim" />
                </div>
                <span className="category-label">Men's Swim</span>
              </Link>
            </div>
          </div>
        </section>

        <section className="promo-grid-3">
          <div className="promo-item">
            <img src="/main/main3-1.jpeg" alt="Dresses" className="promo-bg" />
            <div className="promo-content">
              <h3 className="promo-title">dresses</h3>
              <Link to="/shop" className="btn-shop">
                Shop Now
              </Link>
            </div>
          </div>
          <div className="promo-item">
            <img
              src="/main/main3-2.jpeg"
              alt="Button Downs"
              className="promo-bg"
            />
            <div className="promo-content">
              <h3 className="promo-title">buttons downs</h3>
              <Link to="/shop" className="btn-shop">
                Shop Now
              </Link>
            </div>
          </div>
          <div className="promo-item">
            <img src="/main/main3-3.jpeg" alt="Basics" className="promo-bg" />
            <div className="promo-content">
              <h3 className="promo-title">basics</h3>
              <Link to="/shop" className="btn-shop">
                Shop Now
                <span className="dropdown-arrow"></span>
              </Link>
            </div>
          </div>
        </section>

        <section className="trending-now">
          <h2 className="section-title">Trending Now</h2>
          <div className="trending-banner">
            <img
              src="/main/main4.jpeg"
              alt="For Warmer Days"
              className="trending-bg"
            />
            <div className="trending-content">
              <p className="trending-subtitle">
                New lightweight styles built for cool, comfortable wear.
              </p>
              <div className="trending-buttons">
                <Link to="/shop" className="btn-shop">
                  Women's New Arrivals
                </Link>
                <Link to="/shop" className="btn-shop">
                  Men's New Arrivals
                </Link>
              </div>
              <h3 className="trending-title">for warmer days</h3>
            </div>
          </div>
        </section>

        <section className="promo-grid-2">
          <div className="promo-item">
            <img
              src="/main/main5-1.jpeg"
              alt="More sizes, a better fit"
              className="promo-bg"
            />
            <div className="promo-content text-center">
              <h3 className="promo-title">more sizes. a better fit.</h3>
              <p className="promo-desc">
                Expanded cup sizes for even more support and comfort.
              </p>
              <Link to="/shop" className="btn-shop">
                Shop Now
              </Link>
            </div>
          </div>
          <div className="promo-item">
            <img
              src="/main/main5-2.jpeg"
              alt="A single splash"
              className="promo-bg"
            />
            <div className="promo-content text-center">
              <h3 className="promo-title">a single splash</h3>
              <p className="promo-desc">
                High-performance swimwear built for sun, salt, and long days
                that restore you.
              </p>
              <Link to="/shop" className="btn-shop">
                Shop Now
                <span className="dropdown-arrow"></span>
              </Link>
            </div>
          </div>
        </section>

        <section className="customers-also-love">
          <h2 className="section-title">Customers Also Love</h2>
          <div className="product-carousel">
            {productData.slice(0, 12).map((product) => (
              <div className="product-card" key={product.id}>
                <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                  <div className="image-wrapper">
                    {product.id === 1 && (
                      <span className="badge new-colors">New Colors</span>
                    )}
                    <img
                      src={product.image}
                      alt={product.name}
                      className="primary-image"
                    />
                    {product.images && product.images[1] && (
                      <img
                        src={product.images[1]}
                        alt={`${product.name} hover`}
                        className="hover-image"
                      />
                    )}
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <div className="product-bottom">
                      <span className="regular-price">${product.price}</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
